import { SET_BOOKING_FILTERS, SET_BOOKINGS_VIEW_TYPE, SET_SELECTED_BOOKING } from './actionTypes';

export const setBookingFilters = filters => ({
	type: SET_BOOKING_FILTERS,
	payload: filters
});

export const setSelectedBooking = id => ({
	type: SET_SELECTED_BOOKING,
	payload: id
});
export const setBookingsViewType = type => ({
	type: SET_BOOKINGS_VIEW_TYPE,
	payload: type
});
